var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.215 1A4.238 4.238 0 018.75 2.924c.228-.196.474-.386.736-.573 1.164-.828 2.298-1.324 3.49-1.32 1.12.003 2.193.45 2.988 1.246a4.21 4.21 0 011.247 3.002 4.15 4.15 0 01-1.226 2.957h0l-6.842 6.828L2.247 8.18A4.213 4.213 0 011 5.177a4.145 4.145 0 011.222-2.953A4.238 4.238 0 015.215 1z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
export default SvgHeartSolid;